import { store } from '@/store/store';
import { lecturas_codigo_barras } from '@/shared/dtos/lecturas_codigo_barras';
import {
    VuexModule,
    Mutation,
    getModule,
    Module,
    Action
} from 'vuex-module-decorators';
import { ssmHttpService } from '@/shared/services/http-service';
import { API } from '@/shared/api';

@Module({
    namespaced: true,
    name: 'lecturas_codigo_barrasModule',
    store,
    dynamic: true
})
class lecturas_codigo_barrasModule extends VuexModule {
    public lecturas_codigo_barrases: lecturas_codigo_barras[] = [];
    public lecturas_codigo_barras: lecturas_codigo_barras = new lecturas_codigo_barras();

    @Action({ commit: 'onGetlecturas_codigo_barrases' })
    public async getlecturas_codigo_barrases() {
        return await ssmHttpService.get(API.lecturas_codigo_barras);
    }

    @Action({ commit: 'onGetlecturas_codigo_barras' })
    public async getlecturas_codigo_barras(id: any) {
        return await ssmHttpService.get(API.lecturas_codigo_barras + '/' + id);
    }
    @Action({ commit: 'onGetlecturas_codigo_barras' })
    public async getlecturas_codigo_barras_last() {
        return await ssmHttpService.get(API.lecturas_codigo_barras + '/last', null, false);
    }
    @Action
    public async guardarlecturas_codigo_barras(lecturas_codigo_barras: lecturas_codigo_barras) {
        return await ssmHttpService.post(API.lecturas_codigo_barras, lecturas_codigo_barras.toJson());
    }

    @Action
    public async modificarlecturas_codigo_barras(lecturas_codigo_barras: lecturas_codigo_barras) {
        return await ssmHttpService.put(API.lecturas_codigo_barras + '/' + lecturas_codigo_barras.id, lecturas_codigo_barras);
    }

    @Action
    public async eliminarlecturas_codigo_barras(lecturas_codigo_barras: lecturas_codigo_barras) {
        return await ssmHttpService.delete(API.lecturas_codigo_barras + '/' + lecturas_codigo_barras.id, null, false);
    }

    @Mutation
    public onGetlecturas_codigo_barrases(res: lecturas_codigo_barras[]) {
        this.lecturas_codigo_barrases = res ? res.map((x) => new lecturas_codigo_barras(x)) : []
    }

    @Mutation
    public onGetlecturas_codigo_barras(res: lecturas_codigo_barras) {
        this.lecturas_codigo_barras = new lecturas_codigo_barras(res);
    }

}
export default getModule(lecturas_codigo_barrasModule);